import { Box, Callout, FluidImage, SquareImageContainer } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import styles, { stylesheet } from './ImageTile.module.scss';

interface Image {
    src: string;
    altText: string;
    industryLabel: string;
}

interface ImageTileProps {
    image: Image;
    position?: 'center' | 'left' | 'right' | 'hidden';
    isTabbable?: boolean;
}

const ImageTile = ({ image, position, isTabbable = true }: ImageTileProps) => {
    useStyles(stylesheet);

    return (
        <Box className={styles.imageTile} tabIndex={isTabbable ? 0 : -1}>
            <SquareImageContainer>
                <FluidImage src={image.src} alt={image.altText} />
            </SquareImageContainer>
            <Box
                className={`${styles.calloutWrapper} ${position === 'center' ? styles.centerTile : ''}`}
            >
                <Callout>{image.industryLabel}</Callout>
            </Box>
        </Box>
    );
};

export default ImageTile;
